if (!customElements.get('social-slider')) {
  class SocialSlider extends HTMLElement {
    constructor() {
      super();
      this.beholdUrl = this.dataset.beholdUrl;
      this.sliderWrapper = this.querySelector('[data-social-slider-wrapper]');
      this.slidesData = [];
      this.flickityInstance = null;
    }

    connectedCallback() {
      if (this.beholdUrl && this.sliderWrapper) {
        this.fetchBeholdData();
      }
    }

    fetchBeholdData() {
      fetch(this.beholdUrl)
        .then((response) => response.json())
        .then((data) => {
          if (data && Array.isArray(data.posts)) {
            this.createSlides(data.posts);
          } else {
            console.log('Behold feed data is not in the expected format.');
            this.sliderWrapper.innerHTML = '<p class="error-message">Failed to load social posts.</p>';
          }
        })
        .catch(error => {
          console.log('Error fetching Behold feed:', error);
          this.sliderWrapper.innerHTML = '<p class="error-message">Failed to load social posts.</p>';
        });
    }

    createSlides(posts) {
      posts.forEach(post => {
        const slide = document.createElement('div');
        slide.classList.add('slide');
    
        if (post.mediaUrl && post.permalink !== null) {
          const link = document.createElement('a');
          link.href = post.permalink;
          link.target = '_blank';
          link.title = 'Visit post on social media';
          const aspectRatioWrapper = document.createElement('div');
          aspectRatioWrapper.classList.add('aspect-ratio-wrapper');
          
          const img = document.createElement('img');
          img.src = post.mediaUrl;
          img.loading = "lazy";
          img.width = 600;
          img.height = 600;
          img.alt = post.caption || 'Social Post';
    
          aspectRatioWrapper.appendChild(img);
          link.appendChild(aspectRatioWrapper);
          slide.appendChild(link);
        }
    
        this.sliderWrapper.appendChild(slide);
      });
    
      this.initializeFlickity();
    }
    

    initializeFlickity() {
      if (this.sliderWrapper && this.sliderWrapper.children.length > 0 && !this.flickityInstance) {
        this.flickityInstance = new Flickity(this.sliderWrapper, {
          pageDots: false,
          prevNextButtons: false,
          draggable: true,
          groupCells: true,
          wrapAround: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                groupCells: true,
                wrapAround: true
              }
            }
          ]
        });
      }
    }
  }

  customElements.define('social-slider', SocialSlider);
}